{
  "agreements": {
    "column": {
      "claim-option": "Antragsoption",
      "currency": "Währung",
      "description": "Beschreibung",
      "more": "mehr",
      "number": "Nr.",
      "type": "Typ",
      "valid-from": "Gültig ab",
      "valid-to": "Gültig bis"
    },
    "header": {
      "intro": "Sehen Sie Ihre aktuellen Vereinbarungen ein. Klicken Sie auf die Schaltfläche „Antrag einreichen“, um einen Antrag zu starten.",
      "title": "Übersicht der Vereinbarungen"
    },
    "product": {
      "billback-rate": "Billback-Satz / kg.",
      "code": "LW-Code",
      "name": "Produkte"
    },
    "table": {
      "detail": {
        "contact": "Kontakt:",
        "lwm-contact": "LW-Kontakt:",
        "download-pdf": "Vereinbarung als PDF herunterladen"
      },
      "empty": "Keine Vereinbarungen verfügbar",
      "submit-claim": "Antrag einreichen"
    },
    "type": {
      "billback": "Billback-Vereinbarung QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "Das Passwort muss die folgenden Anforderungen erfüllen: Mindestlänge von 6 Zeichen; englische Großbuchstaben (A-Z), englische Kleinbuchstaben (a-z), Ziffern von 0-9",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "2 Validierungsfehler festgestellt: Wert von \"Passwort\" erfüllte die Bedingungen nicht. Passwort muss das regelmäßige Expressionsmuster erfüllen: ^[\\S]+.*[\\S]+$; Wert bei \"Passwort\" erfüllt Bedingungen nicht: Passwort muss mindestens 6 Zeichen haben.",
    "Account recovery requires verified contact information": "Wiederherstellung des Kontos erfordert die Verifizierung der Kontaktinformationen",
    "An account with the given email already exists.": "Ein Konto mit der angegebenen E-Mail-Adresse besteht bereits",
    "Apply code from MFA app": "Geben Sie den Code Ihrer Multi-Faktor-Authentifizierung ein.",
    "Apply code from SMS": "Geben Sie den Code ein, der an Ihr Mobiltelefon gesendet wurde.",
    "Back to Sign In": "Zurück zur Anmeldung",
    "Cancel": "Löschen",
    "Change Password": "Passwort ändern",
    "Code": "Code",
    "Confirm": "Bestätigen",
    "Confirm password": "Passwort bestätigen",
    "Confirm Sign In": "Anmeldung bestätigen",
    "Confirm Sign Up": "Wir haben Ihnen per E-Mail einen Bestätigungscode geschickt.",
    "Confirm a Code": "Einen Code bestätigen",
    "Confirmation Code": "Bestätigungscode",
    "Create Account": "Konto erstellen",
    "Create a new account": "Ein neues Konto erstellen",
    "Create account": "Konto erstellen",
    "Custom auth lambda trigger is not configured for the user pool.": "Benutzername kann nicht leer sein",
    "Email": "E-Mail",
    "Email address": "E-Mail-Adresse",
    "Enter your Email address": "Geben Sie Ihre E-Mail-Adresse ein",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot Password": "Passwort vergessen",
    "Forgot your password? ": "Haben Sie Ihr Passwort vergessen?",
    "Have an account? ": "Haben Sie ein Konto?",
    "Incorrect username or password": "Inkorrekter Benutzername oder inkorrektes Passwort",
    "Invalid code received for user": "Ungültigen Code erhalten für Benutzer",
    "Invalid password format": "Inkorrektes Passwortformat",
    "Invalid phone number format": "Inkorrektes Telefonnummernformat",
    "Loading": "Wird geladen",
    "Lost your code? ": "Haben Sie Ihren Code vergessen?",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Konto?",
    "Password": "Passwort",
    "Password attempts exceeded": "Anzahl an Versuchen für die Passworteingabe überschritten",
    "Phone Number": "Telefonnummer",
    "Please confirm your password": "Bitte bestätigen Sie Ihr Passwort",
    "Remember this device": "Dieses Gerät abspeichern",
    "Resend Code": "Code erneut senden",
    "Reset password": "Passwort zurücksetzen",
    "Reset your password": "Setzen Sie Ihr Passwort zurück",
    "Send Code": "Code senden",
    "Set MFA": "MFA einstellen",
    "Sign In": "Anmelden",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrierung",
    "Sign in": "Anmeldung  ",
    "Sign in to your account": "Melden Sie sich in Ihrem Konto an",
    "Skip": "Überspringen",
    "Submit": "Absenden",
    "User already exists": "Benutzer existiert bereits",
    "User does not exist": "Benutzer existiert nicht",
    "User does not exist.": "Benutzer existiert nicht.",
    "Username": "Benutzername",
    "Username cannot be empty": "Benutzername kann nicht leer sein",
    "Username/client id combination not found.": "Kombination aus Benutzername/Kunden-ID nicht gefunden.",
    "Verification Code": "Verifizierungscode",
    "Verify": "Verifizieren",
    "Verify Contact": "Kontakt verifizieren",
    "Verify Token": "Verifizieren"
  },
  "authentication": {
    "link-corporate": "Gehe zu",
    "verification_message": "Adresse",
    "warning": {
      "requires-mfa": "Dies ist nur für Nutzer verfügbar, die Multi-Faktor-Authentifizierung aktiviert haben. Sie können Ihre Multi-Faktor Authentifizierung einrichten in"
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Billback-Betrag",
      "contract-no": "Vertragsnr.",
      "description": "Beschreibung",
      "info": "Info",
      "posting-date": "Datum",
      "status": "Status",
      "type": "Typ"
    },
    "empty": "Keine Anträge verfügbar",
    "header": {
      "intro": "Sehen Sie Ihre aktuellen Anträge ein.",
      "title": "Übersicht der eingereichten Anträge"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Meldung schließen",
        "message": "Sehr geehrter Kunde, vielen Dank für Ihre Angaben. Ihr Antrag wird geprüft und innerhalb von 3 bis 4 Wochen abgewickelt. Bei Fragen wenden Sie sich bitte an Ihren kaufmännischen Ansprechpartner bei LW/M.",
        "title": "Ihr Antrag wurde eingereicht"
      },
      "footer": {
        "back": "Zurück",
        "next": "Weiter",
        "submit": "Antrag einreichen",
        "total-billback-amount": "Gesamter Billback-Betrag",
        "total-claim-amount": "Gesamter Antragsbetrag: ",
        "total-volume": "Gesamtvolumen: "
      },
      "items": {
        "bags": "Beutel",
        "billback-amount": "Billback-Betrag",
        "billback-rate": "Billback-Satz",
        "boxes": "Kartons",
        "volume": "Volumen"
      },
      "new-claim-button": "Neuen Antrag einreichen",
      "repeat-button": {
        "large1": "Möchten Sie einen anderen Antrag starten?",
        "large2": "Zurück zur Antragsübersicht",
        "small": "Antragsübersicht"
      },
      "steps": {
        "claim-details": "Antragsdetails ausfüllen",
        "claim-summary": "Antragsübersicht",
        "details": {
          "agreement-details": "Details der Vereinbarung",
          "applicant": "Antragsteller",
          "currency": "Währung:",
          "header": "Antragsdetails",
          "valid-range": "Gültig von-bis: {from} bis {to}",
          "wholesale-party": "Großhändler"
        },
        "details-form": {
          "credit-reference": {
            "label": "Gutschriftsreferenz",
            "placeholder": "Bitte geben Sie Ihre Gutschriftsreferenz ein"
          },
          "header": "Antragsdetails ausfüllen",
          "intro": "Bitte wählen Sie die Produkte für Ihren Rückvergütungsantrag aus. Wir bitten Sie außerdem, den Großhändler anzugeben, bei dem Sie Ihre Produkte bestellt haben.",
          "period": {
            "clear": "Zurücksetzen",
            "label": "Antragszeitraum von - bis",
            "placeholder": "Bitte wählen Sie Ihren Antragszeitraum"
          },
          "wholesale-party": {
            "label": "Großhändler",
            "placeholder": "Bitte geben Sie Ihren Großhändler ein"
          }
        },
        "proof": {
          "attachment": {
            "label": "Bitte legen Sie für alle oben hinzugefügten Positionen einen Kaufnachweis vor",
            "placeholder": "Dateien hierher ziehen und ablegen oder zum Hochladen klicken.  (max. 25 MB) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG unterstützt"
          },
          "header": "Nachweis erbringen"
        },
        "summary": {
          "header": "Zusammenfassung Ihres Antrags ",
          "your-billback-claim": "Ihr Billback-Antrag"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "Bei Fragen wenden Sie sich bitte an Ihren kaufmännischen Ansprechpartner bei LW EMEA.",
        "title": "Antragsübersicht"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Suche…"
      },
      "total": "Gesamt"
    },
    "status": {
      "failed": "Fehlgeschlagen",
      "submitted": "Eingereicht"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Zurück",
      "calculate": "Berechnen",
      "download": "Herunterladen",
      "next": "Nächste/nächster/nächstes"
    },
    "download": {
      "download": "Laden Sie Ihre Auftragskalkulation herunter ",
      "file-type": "CSV-Datei",
      "intro": {
        "done": "Die Berechnung Ihrer Containerbestellung ist abgeschlossen!",
        "download": "Sie können Ihre Containerberechnung als CSV-Datei herunterladen."
      },
      "title": "Auftragsberechnung CSV-Download"
    },
    "header": {
      "intro": {
        "step-1": "Bitte wählen Sie aus, ob wir für Ihre Containerbestellung ein Slipsheet oder Paletten verwenden sollen.",
        "step-2": "Fügen Sie die gewünschten Produkte hinzu.",
        "step-3": "Das System errechnet, ob eventuell zusätzliche Nachfüllartikel erforderlich sind, um den Platz im Container zu maximieren."
      },
      "title": "Produkte für Container auswählen"
    },
    "load-base": {
      "pallet": "Paletten",
      "sheet": "Sheets"
    },
    "result": {
      "filled": {
        "description": "Bitte klicken Sie auf “Weiter”, um fortzufahren.",
        "message": "Ihre aktuelle Produktauswahl passt in einen Container. "
      },
      "initial": {
        "description": "",
        "message": "Wir helfen Ihnen dabei, den Container bis zum maximal verfügbaren Platz zu füllen. Bitte geben Sie die Palettenmenge ein und klicken Sie auf “Berechnen”. Gegebenenfalls gibt der Rechner eine Rückmeldung zur Optimierung des Containerplatzes."
      },
      "overfilled": {
        "description": "Wir haben Ihnen einen Vorschlag für den Artikel mit der höchsten Menge gemacht, den Sie akzeptieren können, indem Sie auf die orangefarbene Schaltfläche klicken. Es steht Ihnen frei, alternative Anpassungen vorzunehmen, indem Sie die Anzahl jedes Artikels in der Liste ändern. Klicken Sie auf “Weiter”, sobald der gesamte Containerplatz ausgefüllt ist.",
        "message": "Um den Container bis zur maximalen Kapazität zu füllen, müssen Paletten entfernt werden."
      },
      "overfilled-no-product": {
        "description": "Ihre aktuelle Produktauswahl passt nicht in den verfügbaren Containerplatz. Bitte reduzieren Sie Ihre Produktauswahl um {count} Paletten.",
        "message": "Sie haben zu viele Paletten hinzugefügt."
      },
      "totals": {
        "boxes": "Kartons:",
        "kg": "kg",
        "pallets": "Paletten:",
        "title": "Gesamt",
        "weight": "Geschätztes Bruttogewicht:"
      },
      "underfilled": {
        "description": "Wir haben für Sie einen Vorschlag auf der Grundlage des Artikels mit der größten Menge gemacht. Sie können diese Konfiguration übernehmen, indem Sie auf die orangefarbene Schaltfläche klicken. Es steht Ihnen frei, alternative Anpassungen vorzunehmen, indem Sie die Anzahl jedes Artikels in der Liste ändern. Klicken Sie auf “Weiter”, sobald der gesamte Containerplatz ausgefüllt ist.",
        "message": "Um den Container bis zur maximalen Kapazität zu füllen, müssen Paletten hinzugefügt werden."
      }
    },
    "steps": {
      "select-products": "Wählen Sie Produkte für den Container aus.",
      "summary": "Auftragsberechnung CSV-Download"
    },
    "suggestion": {
      "add": "Hinzufügen {amount}",
      "reduce": "Entfernen {amount}"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "Vertrag Nr.:",
        "to": "an",
        "total-volume": "Gesamtes Vertragsvolumen:",
        "valid-from-to": "Gültig von/bis"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "Aufgrund von Marktveränderungen können sich die Angaben in Ihren Volumenverträgen ändern. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Marktveränderungen"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Produkttausch in Verträgen"
      },
      "button": "Zu meinen Volumenverträgen",
      "card": {
        "link": "Haftungsausschluss",
        "text": "Lesen Sie unseren Haftungsausschluss, um mehr Informationen über mögliche Abweichungen in dieser Übersicht zu erhalten."
      },
      "need-help": {
        "content": "Wenn Sie weitere Fragen haben oder detailliertere Informationen über Ihre Volumenverträge benötigen, wenden Sie sich an Ihre {link}",
        "link": "Kontaktperson oder das Kundenerfahrungsteam.",
        "title": "Brauchen Sie Hilfe?"
      },
      "title": "Haftungsausschluss"
    },
    "download": {
      "button": "Herunterladen",
      "label": "Wählen Sie die Vertragsinformationen, die Sie herunterladen möchten."
    },
    "header": {
      "intro": "Erhalten Sie Einblick in Ihre Verträge. Wenn Sie Fragen haben, können Sie uns gern kontaktieren.",
      "title": "Meine Volumenverträge"
    },
    "products": {
      "header": {
        "billed-qty": "Abgerechnete Menge KG",
        "code": "LW-Code",
        "contract-qty": "Vertragsmenge KG",
        "kg-left": "KG übrig",
        "material": "Material",
        "open-orders": "Offene Aufträge KG",
        "percent-left": "% übrig",
        "product": "Produktname"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Gehen Sie zu Meine Rechnungen",
      "my-invoices": "Meine Rechnungen",
      "open-invoices": "Offene Rechnungen",
      "upcoming": "Fällige Rechnungen",
      "your-open-invoices": "Ihre offenen Rechnungen"
    },
    "orders": {
      "go-to-orders-overview": "Gehen Sie zum Überblick Bestellungen & Lieferungen",
      "last-order": "Letzte Bestellung",
      "my-orders-deliveries": "Meine Bestellungen & Lieferungen",
      "no-last-order": "Keine letzte Bestellung verfügbar",
      "order-date": "Bestelldatum:",
      "order-status": "Status Ihrer Bestellung",
      "your-orders-deliveries": "Ihre Bestellung & Lieferung"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Fortfahren",
      "enroll": "Anmelden",
      "view": "Anzeigen"
    },
    "course": {
      "finish": {
        "button": "Ich habe diesen Kurs abgeschlossen",
        "description": "Bitte auf die Schaltfläche klicken, um den Abschluss dieses Kurses zu bestätigen",
        "title": "Haben Sie diesen Kurs abgeschlossen?"
      },
      "header": {
        "back": "Zurück zur Übersicht",
        "status": "Status:"
      },
      "related": {
        "default-title": "Andere Kurse"
      }
    },
    "minutes": "Minuten",
    "overview": {
      "empty": "Keine Kurse gefunden",
      "search-bar": {
        "category": {
          "all": "Alle",
          "placeholder": "Kategorie: Alle"
        },
        "duration": {
          "all": "Alle",
          "more-than": "Mehr als",
          "placeholder": "Dauer: Alle"
        },
        "result-title": "({count}) Suchergebnisse für: | ({count}) Suchergebnisse für: | ({count}) Suchergebnisse für: ",
        "search": {
          "placeholder": "Suche…"
        },
        "status": {
          "all": "Alle",
          "placeholder": "Status: Alle"
        }
      },
      "title": "E-Learning"
    },
    "status": {
      "completed": "Abgeschlossen",
      "in-progress": "In Arbeit",
      "not-started": "Nicht begonnen"
    }
  },
  "eatThis": {
    "download": "Jetzt downloaden",
    "open": "Jetzt öffnen"
  },
  "error": {
    "error_404": {
      "title": "Ups, Seite nicht gefunden"
    },
    "error_500": {
      "title": "Ups, Seite nicht gefunden"
    },
    "general": {
      "subtitle": "Es scheint, dass diese Seite nicht funktioniert",
      "title": "Ups, unbekannter Fehler"
    }
  },
  "footer": {
    "copyright": "© {year} Lamb Weston. Alle Rechte vorbehalten.",
    "navigation": {
      "privacy": "Datenschutz",
      "profile": "Profil",
      "terms-and-conditions": "Geschäftsbedingungen"
    }
  },
  "general": {
    "for": "für",
    "interface": {
      "back": "Schwarz",
      "cancel": "Löschen",
      "close": "Schließen",
      "remove": "Entfernen",
      "save": "Speichern",
      "update": "Aktualisieren",
      "none": "Keine",
      "noResultsFound": "Keine Ergebnisse gefunden",
      "all": "Alle",
      "create": "Erstellen",
      "next": "Nächste"
    },
    "locale": {
      "de": "Deutsch",
      "en-GB": "Englisch",
      "es": "Spanisch",
      "fr": "Französisch",
      "it": "Italienisch",
      "nl": "Niederländisch"
    },
    "messages": {
      "error": "Ein unerwarteter Fehler ist aufgetreten."
    },
    "table": {
      "not-available": "nicht verfügbar"
    },
    "dialog": {
      "confirm_delete_message": "Sind Sie sicher, dass Sie dieses Element löschen möchten?"
    }
  },
  "home": {
    "intro": "Auf dem Kundenportal von Lamb Weston.",
    "title": "Wilkommen{fullname},",
    "subtitle": "Stolz servieren wir {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Betrag",
      "details": "Informationen",
      "expire-date": "Ablaufdatum",
      "invoice-nr": "Rechnungsnummer",
      "posting-date": "Buchungsdatum",
      "sales-order": "Auftragsdatum",
      "sales-order-show": "Anzeigen",
      "status": "Status"
    },
    "detail": {
      "label": {
        "amount": "Betrag",
        "currency": "Währung",
        "expire-date": "Ablaufdatum",
        "invoice-number": "Rechnungsnummer",
        "order-reference": "Bestellreferenz",
        "payment-terms-code": "Code Zahlungsbedingungen",
        "payment-terms-description": "Beschreibung Zahlungsbedingungen",
        "posting-date": "Buchungsdatum",
        "relevant-bill-to": "Relevante Rechnung zu",
        "relevant-payer": "Relevanter Zahler",
        "sales-order-ship-to": "Auftragsnummer versenden an",
        "type-commercial": "Handelstyp"
      },
      "pdf-download": "PDF-Rechnung herunterladen",
      "sales-order": {
        "close": "Nachricht beenden",
        "order-overview": "Gehe zu Meine Bestellungen",
        "title": "Rechnung {invoice} - Auftragsdatum"
      },
      "show-sales-order": "Auftragsdatum anzeigen"
    },
    "empty": "Keine Rechnungen verfügbar",
    "header": {
      "intro": "Auf dieser Seite können Sie Ihre Rechnung finden und herunterladen. Für weitere Informationen klicken Sie auf eine Zeile.",
      "title": "Meine Rechnungen"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "Alle Rechnungen",
        "filter": "Rechnungen filtern",
        "search": "Suche…"
      },
      "total": "Gesamt",
      "total-filtered": "Insgesamt gefiltert"
    },
    "status": {
      "before due": "fällige Zahlung",
      "cleared": "bezahlt",
      "days-till-due-date": "{count} Tage|{count} Tag|{count} Tage",
      "due date": "Fälligkeitsdatum",
      "overdue": "überfällig",
      "reversed": "rückgängig gemacht"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "Nachzügler",
      "runner": "Läufer",
      "sleeper": "Schläfer",
      "winner": "Gewinner"
    },
    "imageAlt": {
      "icon": "Kategorie Koch Symbol",
      "laggard": "Koch Nachzüglerkategorie",
      "runner": "Koch Läuferkategorie",
      "sleeper": "Koch Schläferkategorie",
      "winner": "Koch Gewinnerkategorie"
    },
    "label": {
      "addDishEquation": "Ihr Gericht wurde der Gleichung hinzugefügt.",
      "categoryResult": {
        "intro": "Nachfolgend finden Sie die Ergebnisse Ihrer Gerichte in den vier Kategorien …",
        "link": "Menü erstellen",
        "outro": "Klicken Sie auf die Kategorie, um zu sehen, welche Ihrer Gerichte in diese Kategorie fallen, und um Tipps zur Optimierung Ihrer Gerichte zu erhalten."
      },
      "companySeatCount": "Wie viele Sitzplätze haben Sie?",
      "companyStaffSize": "Wie viele Angestellte haben Sie?",
      "cost": "Lebensmittelkosten (€)",
      "course": {
        "breakfast": "Frühstück",
        "dinner": "Abendessen",
        "inbetween": "Zwischenmahlzeiten",
        "lunch": "Mittagessen",
        "snack_time": "Snacks"
      },
      "courseDish": "Kurs",
      "dishNotDeleted": "Gericht konnte nicht gelöscht werden",
      "editDish": "Ihr Gericht wurde bearbeitet.",
      "goodCalculation": "Wir benötigen mindestens 5 Gerichte, um eine gute Kalkulation durchzuführen.",
      "helpTime": "Küchenhilfezeit (Min.)",
      "info": {
        "cost": "Gesamtkostenpreis aller Zutaten in dem Gericht.",
        "helpTime": "Zeit, die das Küchenpersonal für die Zubereitung dieses Gerichts benötigt.",
        "popularity": "Wie viele dieser Gerichte werden pro Woche verkauft?",
        "price": "Der Verkaufspreis des Gerichts auf der Speisekarte vor Steuern.",
        "time": "Zeit, die der Koch für die Zubereitung dieses Gerichts benötigt."
      },
      "insufficientDishes": "Wir benötigen mindestens {count} Gerichte, um eine gute Kalkulation durchzuführen.",
      "laggard": {
        "demand": "Geringe Nachfrage",
        "profit": "Niedriger Gewinn"
      },
      "laggards": "Nachzügler ",
      "nameOfDish": "Name des Gerichts",
      "optionRestaurant": "Restaurant",
      "popularity": "Popularität (mal pro Woche)",
      "price": "Verkaufspreis zzgl. MwSt. (€)",
      "runner": {
        "demand": "Große Nachfrage",
        "profit": "Niedriger Gewinn"
      },
      "runners": "Läufer",
      "selectCourse": "Kurs",
      "selectCourseLabel": "Wählen Sie einen Kurs",
      "sleeper": {
        "demand": "Geringe Nachfrage",
        "profit": "Hoher Gewinn"
      },
      "sleepers": "Schläfer",
      "thinkOfYourDish": "Denken Sie an eines Ihrer Gerichte und füllen Sie das Formular aus.",
      "time": "Kochzeit (Min.)",
      "typeOfRestaurant": "Was für eine Art Restaurant haben Sie?",
      "winner": {
        "demand": "Große Nachfrage",
        "profit": "Hoher Gewinn"
      },
      "winners": "Gewinner"
    },
    "overview": {
      "addAnotherDish": "Speichern und ein weiteres hinzufügen",
      "addDish": "Ein Gericht hinzufügen",
      "addDishEquation": "Ein Gericht der Gleichung hinzufügen",
      "calculateNow": "Jetzt berechnen",
      "cancel": "Abbrechen",
      "categoryCompare": "Im Vergleich zu anderen Gerichten auf dem Markt scheint Ihr Gericht ein … zu sein.",
      "categoryResult": {
        "intro": "Dies sind die",
        "outro": "Kurse Ihres Menüs."
      },
      "deleteProfile": "Sie sind dabei, Ihr Profil zu löschen.",
      "dishes": "Gerichte",
      "menuEngineering": "Menü erstellen",
      "results": "Ergebnisse",
      "save": "Speichern",
      "showResults": "Ergebnisse anzeigen",
      "startMenuEngineering": "Beginnen Sie mit der Erstellung Ihres Menüs",
      "testValueDishes": "Testen Sie den Wert Ihrer Gerichte",
      "typeOfRestaurant": "Restaurant-Art",
      "yourDish": "Ihr Gericht"
    },
    "placeholder": {
      "typeOfRestaurant": "IE Steakhouse, Pizzeria etc."
    },
    "results": {
      "back-to-results": "Zurück zu meinen Ergebnissen",
      "title": "Meine Ergebnisse bei der Menü-Erstellung"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Denken Sie an eines Ihrer Gerichte und füllen Sie das Formular aus.",
        "title": "2. Ihr Gericht"
      },
      "hero": {
        "subtitle": "Mithilfe der Menü-Erstellung können Sie Ihre Gerichte auf der Speisekarte bewerten und einen Überblick über Ihre besten und schlechtesten Leistungen erhalten.",
        "title": "Testen Sie den tatsächlichen Wert Ihrer Gerichte."
      },
      "intro": {
        "text": "Bei der Menü-Erstellung werden die Gerichte im Verhältnis zueinander verglichen. Es wird also immer Gewinner, Schläfer, Läufer und Nachzügler geben. Um ein gutes Ergebnis zu erhalten, vergleichen Sie nur ähnliche Gerichte des Menüs (z.B. aus dem Segment “Hauptgerichte\").",
        "title": "Menü-Erstellung",
        "try": "Probieren Sie es für ein Gericht unten!"
      },
      "restaurant-type": {
        "label": "Können Sie uns sagen, was für ein Restaurant?",
        "subtitle": "Was für eine Art Restaurant haben Sie?",
        "title": "1. Restaurant-Art"
      },
      "result": {
        "sign-up": "Vergleichen Sie mit uns Ihre Gerichte."
      }
    }
  },
  "navigation": {
    "approved-products": "{company} Portfolio",
    "back-to-overview": "Zurück zur Übersicht",
    "best-practices": "Optimale Praktiken/Playbook",
    "container-calculation": "Container-Berechnung",
    "dashboard": "Dashboard",
    "e-learning": "E-Learning",
    "eat-this": "Eat This!",
    "lwm-company-information": "Unternehmen Lamb Weston",
    "lwm-contact": "Lamb Weston Kontakte",
    "market-activations": "Marktaktivierungen",
    "menu-engineering": {
      "add-dish": "Gericht hinzufügen",
      "main": "Menü zusammenstellen",
      "my-results": "Mein Ergebnis",
      "try-out": "Testen Sie, wie viel Ihre Gerichte wirklich wert sind"
    },
    "my-agreements": "Meine Vereinbarungen",
    "my-claims": "Meine Anträge",
    "my-invoices": "Meine Rechnungen",
    "my-orders": "Meine Bestellungen & Lieferungen",
    "my-volume-contracts": "Meine Volumenverträge",
    "new-products": "Innovationen & Trends",
    "partnership": "{company} Partnerschaft",
    "permission-mgt": "Genehmigungsverwaltung",
    "product-information": "Produktinformationen",
    "products-for": "{company} Portfolio",
    "settings": {
      "main": "Einstellungen",
      "my-profile": "Mein Profil"
    },
    "sign-out": "Abmelden",
    "sustainability": "Nachhaltigkeitsagenda",
    "training": "Betrieb & Schulung",
    "trend-information": "Trendinformationen",
    "user-management": "Benutzerverwaltung",
    "dock-scheduler": "Dockplaner",
    "dock-scheduler-booking": "Buchungsübersicht",
    "dock-scheduling-rules": "Dockplanungsregeln"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "Der Validierungscode muss 6 Zeichen lang sein.",
        "unknown": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut."
      },
      "finish": "Fertigstellen",
      "qr-description": "Scannen Sie den QR-Code mit Ihrer Authentifizierungsapp, um den MFA-Code zu erhalten.",
      "qr-title": "MFA-Code",
      "step-title": "Legen Sie den Authentifizierungstoken fest.",
      "steps": "Laden Sie die Google-Authentifizierungsapp im Apple- oder Android-Store herunter |Drücken Sie das “+\"-Symbol |Wählen Sie “QR-Code scannen\" |Geben Sie den Code aus der App in das Feld \"Verifizierungscode\" ein.",
      "title": "Authentifizierungsapp"
    },
    "change-mfa": "Ändern",
    "finished": {
      "features-enabled": "Alle Portalfunktionen sind jetzt verfügbar.",
      "finish": "Zur Übersichtsseite",
      "intro": {
        "authenticator": "Vielen Dank, dass Sie Ihre Multi-Faktor-Authentifizierung eingerichtet haben.\nVon jetzt an können Sie sich mit der Multi-Faktor-Authentifizierung mit Ihrer Authentifizierungsapp anmelden.",
        "sms": "Vielen Dank, dass Sie Ihre Multi-Faktor-Authentifizierung eingerichtet haben.\nVon jetzt an können Sie sich mit der Multi-Faktor-Authentifizierung mit einer Textnachricht auf Ihrem Telefon anmelden.\n"
      },
      "title": "Authentifizierung bestätigt!"
    },
    "mfa-preference": "Bevorzugte Multi-Faktor-Authentifizierung",
    "none": {
      "description": "Wenn Sie keine Multi-Faktor-Authentifizierungsmethode festlegen, können Sie nur die Funktionen des Portals nutzen, die diese Methode nicht erfordern. Wenn Sie fortfahren, ohne die MFA einzurichten, wird dieses Popup bei Ihrem nächsten Besuch erneut angezeigt.",
      "finish": "Verwendung ohne MFA",
      "title": "MFA nicht aktivieren"
    },
    "sms": {
      "change-phone": "Telefonnummer ändern",
      "code-sent": "Wir haben Ihnen einen Code auf Ihr Handy geschickt.",
      "finish": "Fertigstellen",
      "request-code": "Code anfordern",
      "steps": "Geben Sie Ihre Telefonnummer ein und drücken Sie auf Code anfordern | Innerhalb weniger Sekunden sollten Sie eine Textnachricht mit einem Verifizierungscode erhalten | Geben Sie den Verifizierungscode ein und drücken Sie auf “Fertigstellen”, um die Aktivierung durchzuführen.",
      "title": "SMS-Textnachrichten"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(Verwenden Sie einen QR-Code und eine MFA-App, um einen Token auf Ihrem mobilen Gerät zu speichern.)",
          "type": "Authentifizierungsapp"
        },
        "none": {
          "label": "",
          "type": "MFA nicht aktivieren"
        },
        "sms": {
          "label": "(Sie erhalten einen Code auf Ihr mobiles Gerät).",
          "type": "SMS-Textnachrichten"
        }
      },
      "explanation-description": "Die Multi-Faktor-Authentifizierung (MFA) fügt Ihrem Benutzernamen und Passwort eine zusätzliche Schutzebene hinzu. Um die SMS-Authentifizierung zu aktivieren, geben Sie bitte oben eine gültige Mobiltelefonnummer an.",
      "explanation-title": "Bevorzugte Multi-Faktor-Authentifizierung",
      "recommend-description": "Aus Sicherheitsgründen empfehlen wir auch die Verwendung der Multi-Faktor-Authentifizierung.",
      "required-description": "Willkommen in Ihrem Kundenportal! Um Zugang zu allen Funktionen des Kundenportals zu erhalten, ist eine Multi-Faktor-Authentifizierung erforderlich. ",
      "title": "Willkommen!"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Diese Produkte erneut bestellen",
        "reorder": "Sie möchten die Bestellung wiederholen? Klicken Sie auf den Diese Produkte erneut bestellen Button.",
        "summary-info": "* Die Zusammenstellung der Bestellung kann, abhängig vom Lagerbestand, abweichen; eine Bestätigung der Artikel und Mengen folgt schnellstmöglich. Lamb Weston und seine Logistikpartner tun ihr Bestes, um Ihren Wunschtermin einzuhalten, der tatsächliche Liefertermin wird Ihnen jedoch zu einem späteren Zeitpunkt mitgeteilt."
      },
      "header": {
        "bill-of-lading": "BOL:",
        "close": "Schließen",
        "container-numbers-long": "Containermenge ({count})",
        "container-numbers-short": "NR.",
        "more": "mehr",
        "order-city": "Bestimmung",
        "order-date": "Bestelldatum:",
        "order-no": "LW Nr.:",
        "order-ref": "Bestellref.:",
        "order-reference": "Bestellreferenz:",
        "products-to-order": "Zu bestellende Produkte"
      },
      "status": {
        "delivery-date": "Lieferung:",
        "label": "Status:",
        "more-info": "mehr Informationen zum Bestellstatus"
      }
    },
    "group": {
      "last-order": "Ihre letzte Bestellung",
      "see-products": "Hier klicken, um Produkte zu sehen"
    },
    "header": {
      "intro": "Sie können neue Bestellungen aufgeben, Ihre Bestellhistorie ansehen oder schnell eine Nachbestellung einer früheren Bestellung unten aufgeben.",
      "new-order-button": "Neue Bestellung aufgeben",
      "title": "Meine Bestellungen"
    },
    "new": {
      "confirm-dialog": {
        "button": "Nachricht schließen",
        "message": "Unsere Kundenservice-Abteilung wird die Bestellung bestätigen. Es kann einen Augenblick dauern, bis Ihre Bestellung in der Bestellübersicht erscheint.",
        "title": "Vielen Dank für Ihre Bestellung bei Lamb Weston"
      },
      "footer": {
        "back": "Zurück",
        "cancel": "Abbrechen",
        "confirm": "Bestellung bestätigen",
        "next": "Weiter",
        "recalculate": "Neuberechnung"
      },
      "preferred-warehouse": "**Sie haben das Lager: {code} ausgewählt,** aufgrund dieser Auswahl können Sie für diese Bestellung **nur Produkte aus diesem Lager bestellen.** Wenn Sie Produkte aus **einem anderen Lager** bestellen möchten, **erstellen Sie bitte eine separate Bestellung.**",
      "help-text": "Die Produktbezeichnungen beinhalten die Schnittgrößen sowie das Verpackungsgewicht.",
      "intro": "Sie können schnell und einfach bestellen. Sobald Ihre Bestellung in unserem System ist und verarbeitet wurde, erhalten Sie die Zahlungs- und Lieferinformationen von unserer Customer-Experience-Abteilung.",
      "products-title": "Lamb Weston Produktserie",
      "products-unavailable": {
        "button": "Zur Produktauswahl",
        "item-label": "Nicht lieferbar",
        "message": "Ihre aktuelle Nachbestellung enthält ein Produkt, das leider nicht mehr lieferbar ist. Bitte wählen Sie in der Produktauswahl stattdessen ein anderes Produkt. Die restlichen Produkte aus Ihrer vorigen Bestellung haben wir zu Ihrer Bestellliste hinzugefügt.",
        "title": "Diese Produkte erneut bestellen - {count} Produkt(e) nicht lieferbar"
      },
      "repeat-button": {
        "large1": "Möchten Sie Produkte aus einer vorherigen Bestellung erneut bestellen?",
        "large2": "Zurück zur Bestellübersicht",
        "small": "Bestellung wiederholen?"
      },
      "steps": {
        "order-reference-and-shipping": "Bestellreferenz & Versand",
        "order-summary-and-confirmation": "Bestellübersicht & Bestätigung",
        "select-products": "Produkte auswählen"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "Zum Bestätigen bitte auf die orangefarbene Schaltfläche klicken. Es steht Ihnen frei, andere Anpassungen vorzunehmen, indem Sie die Bestellmenge eines beliebigen Artikels in der Liste ändern, oder Sie können unseren Vorschlag ignorieren und mit dem nächsten Schritt des Bestellvorgangs fortfahren.",
          "title": "Wir können Ihre Bestellung optimieren! Wir haben einen Vorschlag für Sie zusammengestellt, damit Ihre Bestellung in die nächste Staffel der Bestellmengen passt."
        },
        "tooltip": {
          "message": "Fügen Sie **+{quantity}** Palette(n) hinzu, um von den niedrigeren Frachtpreisen in der Staffel zu profitieren.",
          "title": "Wir können Ihre Bestellung optimieren!"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "Zum Bestätigen bitte auf die orangefarbene Schaltfläche klicken. Es steht Ihnen frei, andere Anpassungen vorzunehmen, indem Sie die Bestellmenge eines beliebigen Artikels in der Liste ändern, oder Sie können unseren Vorschlag ignorieren und mit dem nächsten Schritt des Bestellvorgangs fortfahren.",
          "title": "Wir können Ihre Bestellung optimieren! Wir haben einen Vorschlag für Sie zusammengestellt, damit Ihre Bestellung das zur Verfügung stehende LKW-Volumen optimal nutzt."
        },
        "tooltip": {
          "message": "Fügen Sie **+{quantity}** Palette(n) hinzu, um eine volle LKW-Ladung zu haben.",
          "title": "Wir können Ihre Bestellung optimieren!"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "Wir haben einen Vorschlag für Sie zusammengestellt, der auf Ihren größten Bestellmenge basiert. Zum Bestätigen bitte auf die orangefarbene Schaltfläche klicken. Es steht Ihnen frei, andere Anpassungen vorzunehmen, indem Sie die Bestellmenge eines beliebigen Artikels in der Liste ändern. Klicken Sie auf „Neuberechnung“, wenn Sie Ihre Bestellung angepasst haben, um fortzufahren.",
          "title": "Sie haben das maximale LKW-Gewicht um {quantity} Palette(n) überschritten ({exceededWeight} kg, einschließlich Paletten)."
        },
        "tooltip": {
          "message": "Reduzieren Sie die Bestellmenge für diesen Artikel um **-{quantity}**. Abbrechen, um die Bestellmenge für andere Artikel zu reduzieren.",
          "title": "Sie haben das maximale LKW-Gewicht überschritten."
        }
      },
      "suggestion": {
        "accept": "Bestätigen",
        "cancel": "Abbrechen"
      },
      "title": "Neue Bestellung"
    },
    "custom-label-switch": {
      "title": "Originaletiketten anzeigen",
      "description": "Dies zeigt die originalen Produktinformationen an, die von LambWeston bereitgestellt wurden, wenn sie eingeschaltet sind.",
      "checkbox": "Originalen Produktnamen und Nummer anzeigen"
    },
    "order-item-list": {
      "header": {
        "art": "Material",
        "boxes": "Kisten",
        "code": "LW-Code",
        "warehouse": "Lager",
        "layers": "Schichten",
        "pallets": "Palletten",
        "product": "Produkte auswählen",
        "products": "Produkte",
        "quantity": "Menge",
        "unit-type": "Typ"
      },
      "totals": {
        "grand-total": "Gesamtsumme",
        "kg": "kg",
        "total-cartons": "Kartons | Karton | Kartons",
        "total-gross-weight": "Bruttogewicht",
        "total-layers": "Schichten | Schicht | Schichten",
        "total-net-weight": "Nettogewicht",
        "total-pallets": "Palletten | Pallette | Palletten"
      },
      "unit": {
        "bag": "Beutel (or: Sack)",
        "car": "Kartons",
        "kg": "kg",
        "lay": "Schichten",
        "pal": "Palletten"
      }
    },
    "overview": {
      "closed-orders-title": "abgeschlossene Bestellungen",
      "empty": "Keine Aufträge verfügbar",
      "header": {
        "eta-actual": "ETA aktuell",
        "eta-booked": "ETA gebucht",
        "eta-requested": "Req. ETA",
        "more": "mehr",
        "order-city": "Bestimmung",
        "order-date": "Bestelldatum",
        "order-no": "LW Nr.",
        "order-ref": "Bestellref.",
        "order-reference": "Bestellreferenz",
        "order-status": "Status Ihrer Bestellung"
      },
      "open-orders-title": "offene Bestellungen",
      "search-bar": {
        "query": {
          "placeholder": "Suche nach einer bestimmten Bestellung..."
        },
        "status": {
          "all": "Alle Aufträge",
          "placeholder": "Status der Bestellung"
        }
      }
    },
    "reference": {
      "intro": "Wenn Sie Ihrer Bestellung gerne eine Bestellreferenz/Bestellnummer hinzufügen möchten, füllen Sie bitte das Bestellreferenz-Feld aus.",
      "number": {
        "max-characters": "(max. 20 Zeichen)",
        "placeholder": "Fügen Sie Ihre Bestellreferenznummer hinzu",
        "title": "Bestellreferenz"
      },
      "title": "Ihre Bestellreferenz"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Bevorzugtes Lager festlegen",
        "filter-products": "Produkte filtern",
        "search": "Nach einem bestimmten Produkt suchen …",
        "search-alt": "Suchen"
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "Dieses Datum ist ein Richtwert",
        "title": "Bevorzugtes Lieferdatum"
      },
      "eta": {
        "delayed": "verzögert",
        "early": "früh",
        "eta": "ETA:"
      },
      "ship-to": {
        "title": "Versandadresse "
      },
      "title": "Versand an"
    },
    "status": {
      "AWS_CREATED": "Von Lamb Weston in Empfang genommen",
      "DELIVERED": "Angeliefert",
      "SAP_CANCELLED": "Storniert",
      "SAP_CREATED": "Angenommen",
      "SAP_PROCESSING": "Bearbeitung",
      "SAP_PROCESSING_PART": "Bearbeitung",
      "SAP_SHIPPED": "Versendet",
      "SAP_SHIPPED_PART": "Versendet",
      "SAP_UNKNOWN": "Unbekannt",
      "more-info": {
        "AWS_CREATED": "Die Bestellung wurde über das Kundenportal abgeschlossen und bestätigt. Die Bestätigungs-Email wurde versandt.",
        "DELIVERED": "Bestätigung, dass die Waren am Bestimmungsort ausgeliefert wurden.",
        "SAP_CANCELLED": "Die Bestellung wurde storniert.",
        "SAP_CREATED": "Die Bestellung wurde abgeschlossen, Ausgangsnachricht versendet. Keine Sperrungen oder Rückweisungen.",
        "SAP_PROCESSING": "Die Bestellung wird von LW Kundenservice bearbeitet und geprüft.",
        "SAP_PROCESSING_PART": "Verarbeitung in SAP, teilweise akzeptierte Bestellung.",
        "SAP_SHIPPED": "Bestellung vollständig geladen. PGI erhalten.",
        "SAP_SHIPPED_PART": "SAP-Lieferung erzeugt, Auftrag teilweise angenommen.",
        "SAP_UNKNOWN": "Bitte kontaktieren Sie Ihren Kundenservice-Repräsentanten für weitere Informationen."
      },
      "part": "partly",
      "partly": "nicht vollständig"
    },
    "summary": {
      "delivery-date": "Versandadresse und bevorzugtes Lieferdatum",
      "title": "Bestellübersicht"
    },
    "warning": {
      "requires-mfa": "Die Funktion Bestellmanagement gibt es nur für Benutzer mit aktivierter Multifaktor-Authentifizierung. Sie können Ihre Multifaktor-Authentifizierung hier einrichten:"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Löschen",
        "get": "Lesen",
        "label": "Aktionen",
        "post": "Erstellen",
        "put": "Aktualisieren",
        "tooltip": "Weitere Informationen über Aktionen"
      },
      "configure": {
        "label": "Konfigurieren",
        "tooltip": "Weitere Informationen zum Konfigurieren"
      },
      "delete": {
        "label": "Löschen",
        "tooltip": "Weitere Informationen zum Löschen"
      },
      "effect": {
        "label": "Effekt",
        "tooltip": "Weitere Informationen zum Effekt"
      },
      "endpoint": {
        "label": "Endpunkt",
        "tooltip": "Weitere Informationen zum Endpunkt"
      },
      "field": {
        "label": "Feld"
      },
      "model": {
        "label": "Modell"
      },
      "operator": {
        "label": "Bediener"
      },
      "value": {
        "label": "Wert"
      },
      "wildcard": {
        "label": "Für Wildcard-Endpunkt",
        "tooltip": "Weitere Informationen über Wildcard"
      }
    },
    "effect": {
      "allow": "Erlauben",
      "deny": "Verweigern"
    },
    "intro": "Benutzerrollen und deren Berechtigungen verwalten Bitte wählen Sie zunächst eine Rolle aus oder fügen Sie eine neue Rolle hinzu.",
    "policies": {
      "add": "Neue Richtlinie hinzufügen",
      "configure": {
        "actions": "Aktionen",
        "effect": "Effekt",
        "endpoint": "Endpunkt",
        "for-wildcard-endpoint": "Für Wildcard-Endpunkt",
        "id": "ID",
        "locale": "Standort",
        "title": "Richtlinie konfigurieren",
        "wildcard": "Wildcard"
      },
      "delete": {
        "cancel": "Abbrechen",
        "confirm": "Richtlinie löschen",
        "message": "Möchten Sie diese Richtlinie wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        "success": "Richtlinie erfolgreich gelöscht",
        "title": "Richtlinie wird gelöscht"
      },
      "intro": "Richtlinien für diese Rolle. Sie können Richtlinien für diese Rolle konfigurieren, indem Sie auf “Konfigurieren” klicken und… "
    },
    "policy-form": {
      "cancel": "Abbrechen",
      "endpoint": {
        "label": "Endpunkt",
        "placeholder": "Einen Endpunkt auswählen"
      },
      "filters": {
        "add": "Einen neuen Filter einfügen",
        "title": "Richtlinienfilter"
      },
      "placeholder": {
        "select": {
          "field": "Ein Feld auswählen",
          "model": "Ein Modell auswählen",
          "operator": "Einen Bediener auswählen"
        }
      },
      "submit": "Speichern & Beenden",
      "title": "Richtlinie konfigurieren"
    },
    "role": {
      "add": "Neue Rolle hinzufügen",
      "edit": "Rollennamen bearbeiten",
      "form": {
        "cancel": "Abbrechen",
        "error": "Beim Speichern der Rolle ist ein Fehler aufgetreten",
        "name": {
          "label": "Name",
          "placeholder": "Geben Sie den Namen der Rolle ein"
        },
        "submit": "Speichern",
        "success": "Die Rolle wird gespeichert",
        "title": "Rolle"
      },
      "placeholder": "Rolle wählen"
    },
    "select-role": "Bitte wählen Sie zunächst eine Rolle aus oder klicken Sie auf “Neue Rolle hinzufügen”.",
    "title": "Genehmigungsverwaltung"
  },
  "product-information": {
    "contact": {
      "description": "Möchten Sie sich über ein neues Produkt erkundigen? Oder möchten Sie vielleicht Produktinformationen für ein Produkt anfordern, das nicht in Ihrer Liste enthalten ist?",
      "link": "Kontakt Customer Experience (Kundenerlebnis)",
      "subject": "Kundenportal Produktinformationen"
    },
    "detail": {
      "intro": "Hier finden Sie alle verfügbaren Produktinformationen dieses Produkts.",
      "packaging": {
        "cartons": "Kartons",
        "cm": "cm",
        "commodity-code": "HS Zollcode",
        "dimensions": "Abmessungen",
        "ean-upc": "EAN-Nummer",
        "gross-weight": "Bruttogewicht",
        "height": "Höhe",
        "kg": "kg",
        "layers": "Lagen",
        "length": "Länge",
        "material": "Material",
        "net-weight": "Nettogewicht",
        "pallet-type": "Palettentyp",
        "shelf-life-code": "Haltbarkeitscode",
        "title": "Verpackung & Abmessungen",
        "unit": {
          "bag": "Verpackung/Beutel",
          "car": "Karton",
          "lay": "Lage",
          "pal": "Palette"
        },
        "width": "Breite"
      },
      "product-sheet": {
        "download-button": "PDF-Datenblatt herunterladen",
        "information-list": "Nährwertangaben|Allergen-Angaben|Zubereitungshinweise|Beispielangaben",
        "intro": "In diesem kommerziellen Produktdatenblatt finden Sie die folgenden Informationen.",
        "subtitle": "Kommerzielles Produktspezifikationsblatt PDF",
        "title": "Produktdatenblatt"
      }
    },
    "header": {
      "intro": "Hier finden Sie die verfügbaren Produktinformationen. Klicken Sie auf “Mehr Info\" für weitere Produktdetails.",
      "title": "Produktinformationen"
    },
    "list": {
      "empty": "Keine Produkte verfügbar",
      "header": {
        "details": "Mehr Info",
        "download": "PDF herunterladen"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Kontoeinstellungen bearbeiten",
      "title": "Kontoeinstellungen"
    },
    "edit": "bearbeiten",
    "email": {
      "confirmation-code": "Geben Sie Ihren Bestätigungscode ein"
    },
    "error": {
      "failed": "Beim Speichern Ihres Profils ist ein Fehler aufgetreten",
      "success": "Ihr Profil wurde gespeichert",
      "wrongPassword": "Das von Ihnen eingegebene Passwort ist falsch"
    },
    "label": {
      "cancel": "Abbrechen",
      "change-password": "****************",
      "city": "Stadt",
      "country": "Land",
      "edit": "Profil bearbeiten",
      "email": "E-Mail-Adresse",
      "firstName": "Vorname",
      "functionTitle": "Position",
      "lastName": "Nachname",
      "locale": "Sprache",
      "newPassword": "Neues Passwort",
      "newPasswordRepeat": "Passwort erneut eingeben",
      "oldPassword": "Altes Passwort",
      "phone": "Telefonnummer",
      "restaurantCity": "Stadt",
      "restaurantCountry": "Land",
      "restaurantName": "Restaurant-Name",
      "restaurantNumber": "Nummer",
      "restaurantPostalcode": "PLZ",
      "restaurantSeats": "Sitzplätze für Gäste",
      "restaurantStreet": "Straße",
      "restaurantTelephone": "Telefon",
      "restaurantType": "Restaurant-Art",
      "restaurantWebsite": "Website",
      "save": "Speichern"
    },
    "locale": {
      "change-success": "Die Sprache wurde erfolgreich geändert"
    },
    "mfa": {
      "current-mfa": "Eingerichtet:",
      "method": {
        "NOMFA": "keine Multifaktor-Authentifizierung",
        "SMS": "SMS-Textnachricht. Sie erhalten einen Code auf Ihrem mobilen Gerät.",
        "TOTP": "Einmalpasswort (mit Authentifizierungsapp)"
      },
      "mfa-description": "Die Multifaktor-Authentifizierung fügt eine zusätzliche Schutzebene zu Ihrem Benutzernamen und Passwort hinzu. Um die SMS-Authentifizierung zu aktivieren, geben Sie bitte oben ein gültige Handynummer an.",
      "no-mfa-description": "MFA nicht aktivieren",
      "setup-mfa": "Präferenz für Multifaktor-Authentifizierung",
      "sms-description": "SMS-Textnachrichten (Empfang eines Codes auf Ihrem mobilen Gerät. Ihre Rufnummer muss korrekt eingestellt sein.",
      "token-instructions": "Scannen Sie den QR-Code mit Ihrer Telefonkamera oder Authentifizierungs-App, um den MFA-Code zu erhalten.",
      "totp-description": "Einmaliges Passwort (verwenden Sie einen QR-Code und eine MFA-App, um ein Token auf Ihrem mobilen Gerät zu speichern).",
      "totp-info": {
        "1-select-option": "Wählen Sie als Option \"einmaliges Passwort\" und klicken Sie auf \"MFA einstellen.\"",
        "2-get-app": "Erhalten Sie {0} für Ihr mobiles Gerät.",
        "2-get-app-link": "Google Authenticator App",
        "3-press-plus": "Drücken Sie das \"+\" Symbol",
        "4-select-scan": "Wählen Sie \"QR-Code scannen\"",
        "5-enter-code": "Fügen Sie den Code von der App als \"Verifizierungscode\" ein",
        "title": "So richten Sie die Authentifizierung mit einem Einmalpasswort ein"
      }
    },
    "no-profile-placeholder": "Bitte füllen Sie Ihre Profilinformationen aus, um das Kundenportal optimal nutzen zu können. Klicken Sie auf das Symbol in der rechten Ecke, um zu bearbeiten.",
    "password": {
      "change-success": "Ihr Passwort wurde erfolgreich geändert",
      "do-not-match": "Die Passwörter stimmen nicht überein",
      "invalid": "Das Passwort muss eine Mindestlänge von 6 Zeichen haben und folgende Zeichen enthalten: Großbuchstaben (A-Z, ohne Umlaute); Kleinbuchstaben (a-z, ohne Umlaute); Ziffern von 0-9."
    },
    "phone": {
      "invalid-phone-number": "Die angegebene Rufnummer wird nicht als gültige Rufnummer akzeptiert.",
      "unknown-error": "Es ist etwas schief gelaufen, Ihre Rufnummer konnte nicht gespeichert werden"
    },
    "placeholder": {
      "city": "z. B. Berlin, Hamburg",
      "close": "Schließen",
      "confirmation-code": "'123456",
      "country": "Land auswählen",
      "email": "mail@chefs.network",
      "functionTitle": "z. B. Küchenchef, stellvertretender Küchenchef etc.",
      "number": "z. B. 9, Top 12F etc.",
      "open": "Öffnung",
      "password": "Passwort",
      "phone": "+491520 1234567",
      "restaurant": {
        "seats": "IE 100",
        "type": "IE Steakhouse, Pizzeria etc."
      },
      "staff": "z. B. 2",
      "street": "z. B. Hauptstraße",
      "zip": "z. B. 10178, 1020 etc."
    },
    "restaurant": {
      "add": "Ein weiteres Restaurant hinzufügen",
      "address": "Anschrift",
      "basic": "Basis",
      "delete": {
        "confirm": "Restaurant löschen",
        "message": "Möchten Sie dieses Restaurant wirklich löschen?",
        "success": "Ihr Restaurant wurde gelöscht.",
        "title": "Sie sind dabei, Ihr Restaurant zu löschen."
      },
      "delete-success": "Ihr Restaurant wurde gelöscht.",
      "edit": "Restaurant-Informationen bearbeiten",
      "save-success": "Ihr Restaurant wurde gespeichert.",
      "seats": "Sitzplätze für Gäste",
      "title": "Restaurant-Informationen",
      "type": {
        "(mountain) huts": "(Berg-)Hütten",
        "american diner": "Amerikanisches Diner",
        "american_diner": "Amerikanisches Diner",
        "bar": "Bar",
        "beach resorts": "Strand-Resorts",
        "beach_resorts": "Strand-Resorts",
        "bistro": "Bistro",
        "camp sites": "Campingplätze",
        "camp_sites": "Campingplätze",
        "chicken restaurant": "Geflügel-Restaurant",
        "chicken_restaurant": "Geflügel-Restaurant",
        "fast food": "Fastfood",
        "fast_food": "Fastfood",
        "fish Burger": "Fisch-Burger",
        "fish_burger": "Fisch-Burger",
        "gourmet restaurant": "Gourmet-Restaurant",
        "gourmet_restaurant": "Gourmet-Restaurant",
        "grill restaurant": "Grill-Restaurant",
        "grill_restaurant": "Grill-Restaurant",
        "hamburger Restaurant": "Hamburger-Restaurant",
        "hamburger_restaurant": "Hamburger-Restaurant",
        "mountain_huts": "(Berg-)Hütten",
        "other": "Sonstige",
        "pizza restaurant": "Pizzeria",
        "pizza_restaurant": "Pizzeria",
        "pub": "Pub",
        "seafood restaurant": "Meeresfrüchte-Restaurant",
        "seafood_restaurant": "Meeresfrüchte-Restaurant",
        "snack bar": "Snackbar",
        "snack_bar": "Snackbar",
        "steakhouse": "Steakhouse"
      }
    },
    "title": "Profil"
  },
  "registration": {
    "label": {
      "password": "Passwort",
      "restaurantName": "Bitte geben Sie den Namen des Restaurants an, für das Sie die Menu-Erstellung berechnen möchten."
    },
    "placeholder": {
      "restaurantName": "Restaurant-Name"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Schließen"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Aktualisierung! Neue Funktionen.",
        "read-more": "Mehr lesen",
        "title": "Aktualisierung! Neue Funktionen.",
        "content": [
          {
            "title": "Lieber Kunde,",
            "content": "Bitte beachten Sie, dass wir einige Änderungen in unserem Kundenportal vorgenommen haben. Es gibt jetzt die Möglichkeit, Ihre Produktnummer und -beschreibung im Kundenportal anzeigen zu lassen. Sollte eines Ihrer Produkte oder eine Beschreibung fehlen, melden Sie sich gerne diesbezüglich bei Ihrem Lamb Weston Ansprechpartner.",
            "image": "/img/updates/new-product-cold-store/de/1.jpg"
          },
          {
            "content": "Wollen Sie nur die Codes von Lamb Weston sehen, setzen Sie bitte den Haken bei 'Originalen Produktnamen end Nummer':",
            "image": "/img/updates/new-product-cold-store/de/2.jpg"
          },
          {
            "content": "Ab jetzt wird außerdem der Ort des ausliefernden Lagers dargestellt:",
            "image": "/img/updates/new-product-cold-store/de/3.jpg"
          },
          {
            "content": "Falls Sie weitere Fragen über die obengenannten Anpassungen haben, kontaktieren Sie einfach Ihren Lamb Weston Ansprechpartner."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "E-Mail-Adresse",
        "placeholder": "Benutzer E-Mail-Adresse"
      },
      "error-message": "Beim Hinzufügen eines neuen Benutzers ist ein Fehler aufgetreten.",
      "intro": "Füllen Sie die Informationen unten aus und klicken Sie auf Benutzer hinzufügen, um einen neuen Benutzer hinzuzufügen.",
      "locale": {
        "label": "Sprache",
        "placeholder": "Wählen Sie die bevorzugte Sprache aus"
      },
      "mfa": {
        "phone": "Telefonnummer",
        "title": "Präferenz für Multifaktor-Authentifizierung",
        "use-sms-mfa": "SMS-Textnachricht. Sie erhalten einen Code auf Ihrem mobilen Gerät."
      },
      "sap-id": {
        "customer": "Kunde:",
        "label": "SAP-ID",
        "no-portal-access": "Dieser Kunde hat keinen Zugang zum Kundenportal",
        "placeholder": "SAP-ID besteht aus maximal zwölf Zeichen…",
        "unknown-sap-id": "Unbekannte SAP-ID"
      },
      "success-message": "Der Benutzer wurde erfolgreich hinzugefügt.",
      "user-group": {
        "label": "User group",
        "placeholder": "Wählen Sie die Benutzergruppe aus"
      }
    },
    "add-new-user": "Neuen Benutzer hinzufügen",
    "change-roles": {
      "form": {
        "cancel": "Abbrechen",
        "error": "Die Benutzerrollen konnten nicht gespeichert werden.",
        "label": "Rolle(n) ändern",
        "placeholder": "Eine Rolle hinzufügen",
        "remove": "Diese Rolle entfernen",
        "submit": "Speichern",
        "success": "Die Benutzerrollen wurden erfolgreich gespeichert."
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Abbrechen",
        "error": "Die Benutzergruppe konnte nicht geändert werden.",
        "group": {
          "administrators": "Administrator",
          "any": "Beliebig/beliebige/beliebiger/beliebiges",
          "direct-customers": "Direkter Kunde",
          "end-users": "Endnutzer",
          "indirect-customers": "Indirekter Kunde",
          "multinationals": "Multinational",
          "none": "Kein/keine/keiner/keines",
          "dock-scheduling-users": "Dockplanungsbenutzer",
          "dock-scheduling-employees": "Mitarbeiter der Dockplanung"
        },
        "label": "Benutzergruppe ändern",
        "submit": "Speichern",
        "success": "Die Benutzergruppe wurde erfolgreich geändert."
      }
    },
    "column": {
      "customer": "Kunde",
      "details": "Bearbeiten",
      "email": "E-Mail",
      "first-name": "Vorname",
      "last-name": "Nachname",
      "status": "Status",
      "user-group": "User group",
      "vendor": "Partner"
    },
    "details": {
      "change-roles": "Rollen ändern",
      "change-user-group": "Benutzergruppe ändern",
      "impersonate": "Diesen Benutzer personifizieren",
      "language": "Sprache:",
      "manage-user-intro": "Sie können das Passwort dieses Benutzers oder die Zwei-Faktor-Authentifizierung zurücksetzen, indem Sie auf die Schaltfläche unten klicken.",
      "manage-user-title": "Dieses Benutzerprofil bearbeiten",
      "reset-mfa": "2FA zurücksetzen",
      "reset-password": "Passwort zurücksetzen",
      "sap-id": "SAP-ID:",
      "sap-id-error": "Die SAP-ID konnte nicht geändert werden",
      "sap-id-placeholder": "SAP-ID hinzufügen",
      "sap-id-success": "Die SAP-ID wurde geändert",
      "status": {
        "active": "Aktiv",
        "inactive": "Nicht aktiv"
      },
      "toggle-active-intro": "Durch Umschalten der Taste unten können Sie den Benutzer aktivieren oder deaktivieren",
      "toggle-active-title": "Aktivieren und Deaktivieren eines Benutzers"
    },
    "group": {
      "administrators": "Administratoren",
      "direct-customers": "Direktkunden",
      "end-users": "Endnutzer",
      "indirect-customers": "indirekte Kunden",
      "dock-scheduling-users": "Dockplanungsbenutzer",
      "dock-scheduling-employees": "Mitarbeiter der Dockplanung"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Beliebig/beliebige/beliebiger/beliebiges",
      "direct-customers": "Direktkunde",
      "end-users": "Endnutzer",
      "indirect-customers": "Indirekter Kunde",
      "multinational": "Multinational",
      "none": "Kein/keine/keiner/keines",
      "dock-scheduling-users": "Dockplanungsbenutzer",
      "dock-scheduling-employees": "Mitarbeiter der Dockplanung"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "Sie sind derzeit personifiziert als …",
        "stop": "Personifizierung beenden"
      },
      "dialog": {
        "cancel": "Abbrechen",
        "confirm": "Impersonieren",
        "message": "Sind Sie sicher, dass Sie \"{email}\" impersonieren möchten?",
        "title": "Benutzer impersonieren"
      }
    },
    "intro": "Verwalten Sie Ihre Benutzer. Klicken Sie jetzt auf einen Benutzer für weitere Informationen oder mögliche Benutzeraktionen.",
    "reset-mfa": {
      "cancel": "Löschen",
      "confirm": "Bestätigen",
      "error": "Beim Zurücksetzen der Zwei-Faktor-Authentifizierung ist ein Fehler aufgetreten.",
      "message": "Sind Sie sicher, dass Sie die Zwei-Faktor-Authentifizierung für diesen Benutzer zurücksetzen möchten?",
      "success": "Die Zwei-Faktor-Authentifizierung wurde zurückgesetzt.",
      "title": "Zwei-Faktor-Authentifizierung zurücksetzen"
    },
    "reset-password": {
      "cancel": "Löschen",
      "confirm": "Bestätigen",
      "error": "Beim Zurücksetzen des Passwortes ist ein Fehler aufgetreten.",
      "message": "Sind Sie sicher, dass Sie das Passwort für diesen Benutzer zurücksetzen möchten?",
      "success": "Das Passwort wurde zurückgesetzt.",
      "title": "Passwort zurücksetzen"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Suchen …",
        "search-alt": "suchen",
        "users": "Benutzer"
      }
    },
    "status": {
      "active": "aktiv",
      "cancel": "Löschen",
      "confirm": "Bestätigen",
      "inactive": "nicht aktiv",
      "message": "Sind Sie sicher, dass Sie den Status des Benutzers ändern möchten?",
      "title": "Aktivieren und Deaktivieren eines Benutzers"
    },
    "title": "Benutzerverwaltung",
    "update-vendor-button": "Update-Partner",
    "vendor-label": "Partner",
    "vendor-tooltip": "Eine direkte Integration mit dem SAP-System des Anbieters besteht derzeit nicht. \nDurch das Festlegen eines Werts kann ein Administrator auf der Grundlage dieses Werts Buchungen für diesen Partner erstellen.",
    "product-groups-label": "Produktgruppen",
    "update-product-groups-button": "Produktgruppen aktualisieren"
  },
  "validation": {
    "ext": "Nur Dateien mit der Erweiterung '{ext}' werden akzeptiert.",
    "required": "Dieses Feld ist erforderlich",
    "totalSize": "Sie können nicht mehr als {totalSize}Mb hochladen",
    "quarterly": "Die ausgewählten Monate bilden kein gültiges Quartal",
    "no-special-characters": "Die Eingabe darf keine Hashtags, Anführungszeichen, Sternchen oder Kommas enthalten.",
    "password": "Das Passwort muss mindestens {length} Zeichen lang sein",
    "password-repeat": "Die Passwörter stimmen nicht überein",
    "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "max": "Dieses Feld darf höchstens {max} Zeichen lang sein.",
    "afterTime": "Die Endzeit muss später als die Startzeit liegen",
    "min": "Dieses Feld muss mindestens {min} Zeichen lang sein."
  },
  "dock-management": {
    "dock-scheduler-title": "Dockplaner",
    "select-location": "Standort",
    "select-day": "Tag",
    "dock-scheduler-no-data": "Wählen Sie einen Ort und einen Tag aus, um ein Zeitfenster anzuzeigen und zu reservieren",
    "dock-schedule-table-cell-your-booking": "Ihre Buchung",
    "dock-schedule-table-cell-booked-by-other": "Gebucht",
    "dock-schedule-table-cell-closed": "Geschlossen",
    "error-fetching-locations": "Beim Abrufen der Speicherorte ist ein Fehler aufgetreten",
    "error-fetching-dock-schedule": "Der Zeitplan konnte nicht abgerufen werden",
    "docking-dialog": {
      "booking-id": "@:brand.name buchungsreferenz",
      "license-plate": "Kennzeichen",
      "nationality": "Nationalität",
      "remarks": "Bemerkungen",
      "create-button": "Buch",
      "title": "Andocken für {dock} an {location}",
      "nationality-placeholder": "Wählen Sie eine Nationalität",
      "remarks-placeholder": "Zum Beispiel Ladeanweisungen oder Bemerkungen",
      "supplier-placeholder": "Zum Beispiel Lamb Weston",
      "license-plate-placeholder": "Zum Beispiel 22-BDS-02",
      "confirm-dialog": {
        "message": "Sind Sie sicher, dass Sie diese Buchung entfernen möchten? \nDies wird für alle gelöscht."
      },
      "transporter": "Transporter",
      "booking-id-tooltip": "Eingehende/ausgehende oder Bestellnummer.",
      "error-remove-booking-validation": "Eine Stornierung innerhalb der vereinbarten Frist ist nicht möglich. \nBitte kontaktieren Sie Ihren Ansprechpartner innerhalb von @:brand.name",
      "partner-placeholder": "Wählen Sie einen Partner",
      "partner": "Im Namen von"
    },
    "error-fetching-bookings": "Beim Abrufen der Buchungen ist ein Fehler aufgetreten",
    "success-creating-booking": "Zeitfenster erfolgreich gebucht",
    "error-creating-booking": "Die Buchung eines Zeitfensters ist fehlgeschlagen",
    "success-deleting-booking": "Buchung erfolgreich gelöscht",
    "error-deleting-booking": "Das Löschen einer Buchung ist fehlgeschlagen",
    "success-updating-booking": "Buchung erfolgreich aktualisiert",
    "error-updating-booking": "Die Aktualisierung einer Buchung ist fehlgeschlagen",
    "dock-schedule-table-cell-no-longer-available": "Dieses Zeitfenster ist nicht mehr verfügbar, da es außerhalb des zulässigen Buchungsfensters liegt.",
    "dock-schedule-table-cell-loading-reference-not-found": "Referenznummer konnte nicht gefunden werden",
    "dock-scheduler-closed-day": "Der Standort ist den ganzen Tag geschlossen.",
    "dock-schedule-table-lock-dock-tooltip": "Sie können dieses Dock nicht schließen, da für diesen Tag bereits Buchungen vorliegen",
    "error-unlocking-dock": "Das Entsperren des Docks ist fehlgeschlagen",
    "error-locking-timeslot": "Das Verriegeln des Docks ist fehlgeschlagen",
    "error-fetching-notifications": "Beim Abrufen der Benachrichtigungen ist ein Fehler aufgetreten",
    "location-notifications": {
      "confirm-dialog": {
        "message": "Sind Sie sicher, dass Sie diese Benachrichtigung löschen möchten?"
      },
      "add-notification": "Benachrichtigung erstellen"
    },
    "notification-dialog": {
      "title": "Benachrichtigung",
      "message": "Nachricht",
      "is-active": "Ist aktiv"
    },
    "success-deleting-notification": "Benachrichtigung erfolgreich entfernt",
    "error-deleting-notification": "Die Benachrichtigung konnte nicht entfernt werden",
    "success-creating-notification": "Eine Benachrichtigung wurde erfolgreich erstellt",
    "error-creating-notification": "Fehler beim Erstellen einer Benachrichtigung",
    "success-updating-notification": "Benachrichtigung erfolgreich aktualisiert",
    "location-settings-dialog": {
      "title": "Standorteinstellungen",
      "cutoff-time": "Annahmeschluss"
    },
    "success-updating-cutoff-time": "Annahmeschluss erfolgreich aktualisiert",
    "error-updating-cutoff-time": "Fehler beim Aktualisieren des Annahmeschlusses",
    "cutoff-time-label": "Buchungen für den nächsten Tag schließen um {time} Uhr",
    "error-updating-notification": "Fehler beim Aktualisieren der Benachrichtigung",
    "error-fetching-partners": "Fehler beim Abrufen der Partner",
    "select-booking-period": "Buchungszeitraum",
    "booking-overview-title": "Buchungsübersicht",
    "select-docks": "Docks",
    "export-bookings-button": "Herunterladen",
    "export-bookings-subtitle": "XLSX-Datei",
    "export-bookings-title": "Laden Sie Ihre vergangenen Buchungen herunter",
    "export-bookings-error": "Exportieren fehlgeschlagen",
    "booking-overview-table": {
      "date": "Datum",
      "time": "Zeit",
      "location": "Standort",
      "dock": "Dock",
      "reference-number": "Buchungsreferenz",
      "partner-id": "Externer Partner"
    },
    "dock-booking-overview-no-data": "Keine Daten",
    "dock-scheduling-rules-title": "Dockplanungsregeln",
    "add-dock-scheduling-rule": "Neue Dockplanungsregel",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} Regeln)",
      "no-data": "Es wurden noch keine Regeln erstellt."
    },
    "schedule-dialog": {
      "step-1-instructions": "Wählen Sie einen Standort, ein Dock und eine Produktgruppe aus, um eine neue Regel zu erstellen",
      "title": "Dockplanungsregeln",
      "step-2-location": "Standort",
      "step-2-selected-docks": "Docks",
      "step-2-selected-product-groups": "Produktgruppen",
      "location": "Standort",
      "docks": "Docks",
      "product-groups": "Produktgruppen"
    },
    "error-fetching-product-groups": "Der Empfang der Produktgruppen ist fehlgeschlagen",
    "error-updating-rule": "Fehler beim Aktualisieren der Regel",
    "success-updating-rule": "Regel erfolgreich aktualisiert",
    "error-creating-rule": "Fehler beim Erstellen einer Regel",
    "success-creating-rule": "Regel erfolgreich erstellt",
    "error-deleting-rule": "Fehler beim Löschen der Regel",
    "success-deleting-rule": "Regel erfolgreich gelöscht",
    "error-fetching-rules": "Fehler beim Empfangen der Regeln",
    "error-fetching-rule": "Fehler beim Empfangen der Regeln"
  },
  "days": {
    "monday": "Montag",
    "tuesday": "Dienstag",
    "wednesday": "Mittwoch",
    "thursday": "Donnerstag",
    "friday": "Freitag",
    "saturday": "Samstag",
    "sunday": "Sonntag"
  },
  "userMgtStore": {
    "userVendorUpdated": "Der Partner wurde erfolgreich aktualisiert",
    "userProductGroupUpdated": "Die Produktgruppen wurden erfolgreich aktualisiert"
  },
  "captcha": {
    "error": "Bei der Sicherheitsprüfung ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
    "title": "Sicherheitsüberprüfung",
    "subtitle": "Bitte schließen Sie die folgende Prüfung ab, um fortzufahren"
  }
}
